import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./Components/App";
import { createStore } from "polotno/model/store";
import { setBackground } from "./Components/resize-panel.js";

// create editor
export const createEditor = ({
  container,
  initialConfig,
  uploadUrl,
  fontUrl,
  availableFormats,
}) => {
  const root = ReactDOM.createRoot(container);

  const store = createStore({
    key: window.polotnoKey ?? "WCJdDPbCd7iCXWljd0zz",
    showCredit: false,
  });

  // setup store
  if (initialConfig) {
    store.loadJSON(initialConfig);
  } else {
    store.addPage();
    if (availableFormats.length === 1) {
      setBackground(store, availableFormats[0]);
    }
  }

  store.toggleBleed(true);
  store.toggleRulers(true);

  // set globals
  window.uploadUrl = uploadUrl;
  window.fontUrl = fontUrl;
  window.CUSTOM_SIZES = availableFormats;
  window.polotnoStore = store;

  // render
  root.render(<App store={store} />);
};

// globals
window.createEditor = createEditor;

console.log("package v1.0.1");

history.pushState(null, null, location.href);
window.onpopstate = function () {
  history.go(1);
};
